import moment from 'moment';

const FixedDigitsFormatter = (value, data, propName, props) => {
  if (value && value.toFixed) {
    return value.toFixed((props && props.digits));
  }
  return value;
};

const FIXED_DIGITS_FORMATTER_KEY = 'fixedDigits';
const RoundNumber = (value, fractionDigits, displayTrailingZeros) => {
  if (!fractionDigits) return Math.round(value);
  if (displayTrailingZeros && value.toFixed) {
    return value.toFixed(fractionDigits);
  }
  if (!fractionDigits || !value) return value;
  let m = 1;
  for (let i = 0; i < fractionDigits; i += 1) {
    m *= 10;
  }
  return Math.round(value * m) / m;
};

const PercentageFormatter = (value, data, propName, props = {}) => {
  if (value || (value === 0)) {
    const digits = props.fractionDigits || 0;
    const minValue = props.min === undefined ? 0 : props.min;
    const range = (props.max === undefined ? 1 : props.max) - minValue;
    const { displayTrailingZeros } = props;
    let i = (value - minValue) / range * 100;
    i = RoundNumber(i, digits, displayTrailingZeros);

    let addPercentage;
    if (props.adornments) {
      const { adornments } = props;
      adornments.suffix = '%';
      addPercentage = false; // The text field editing the value is taking care of displaying the %
    } else {
      addPercentage = true;
    }

    return addPercentage && `${i}%` || i;
  }
  return value; // Value is not a number, not adding % nor adornments
};

const PERCENTAGE_FORMATTER_KEY = 'percentage';

const DollarsFormatter = (value, data, propName, props = {}) => {
  const digits = props.fractionDigits || 0;
  const { displayTrailingZeros } = props;
  if (value || (value === 0)) {
    let i = value;
    i = RoundNumber(i, digits, displayTrailingZeros);

    let addDollars;
    if (props.adornments) {
      const { adornments } = props;
      adornments.prefix = '$';
      addDollars = false; // The text field editing the value is taking care of displaying the %
    } else {
      addDollars = true;
    }

    return addDollars && `$${i}` || i;
  }
  return value; // Value is not a number, not adding $nor adornments
};

const DOLLARS_FORMATTER_KEY = 'dollars';

const DATE_FORMATTER_KEY = 'date';
const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY h:mm:ss a';
const DateFormatter = (value, data, propName, props = {}) => {
  const { format } = props;
  if (value || (value === 0)) {
    return moment(value).format(format || DEFAULT_DATE_FORMAT);
  }
  return value; // Value is not a number, not adding $nor adornments
};

const DURATION_FORMATTER_KEY = 'duration';
const DEFAULT_DURATION_UNIT = 'millis';
const DURATION_UNITS = [
  { name: 'days', millis: 24 * 3600 * 1000, title: 'd' },
  { name: 'hours', millis: 3600 * 1000, title: 'h' },
  { name: 'minutes', millis: 60 * 1000, title: 'min' },
  { name: 'seconds', millis: 1000, title: 's' },
  { name: 'millis', millis: 1, title: 'millis' },
];

function printNum(num, isFirst) {
  return isFirst ? num : `${num > 9 ? '' : 0}${num}`;
}

const DurationFormatter = (value, data, propName, props = {}) => {
  const { unit = DEFAULT_DURATION_UNIT, hideZeroValues = false, formatters } = props;
  const getUnitIndex = (name) => {
    for (let i = 0; i < DURATION_UNITS.length; i += 1) {
      if (DURATION_UNITS[i].name === name) {
        return i;
      }
    }
    return -1;
  };
  if (value === undefined) {
    value = 0; // eslint-disable-line
  }
  if (value || (value === 0)) {
    const unitIndex = getUnitIndex(unit);
    if (unitIndex < 0) {
      console.log(`No duration unit with the name ${unit}`);
      return value;
    }
    let r = value * DURATION_UNITS[unitIndex].millis;
    let first = true;
    let n;
    let result = '';
    for (let i = 0; i <= unitIndex; i += 1) {
      n = Math.floor(r / DURATION_UNITS[i].millis);
      if (n || (!first && !hideZeroValues)) {
        r -= n ? DURATION_UNITS[i].millis * n : 0;
        const fmt = formatters && formatters[DURATION_UNITS[i].name];
        if (fmt) {
          result += fmt(n, printNum(n, first), first);
        } else {
          result += `${printNum(n, first)}${DURATION_UNITS[i].title}`;
        }
        first = false;
      } else if ((i === unitIndex) && !hideZeroValues) {
        // try {
        //   result = moment.duration(r / DURATION_UNITS[i].millis, DURATION_UNITS[i].name);
        //   console.log(result);
        //   result = result.humanize();
        //   console.log(result);
        // } catch (e) {
        //   console.log(e);
        //   result = `<1${DURATION_UNITS[i].title}`;
        // }
        result = `${r / DURATION_UNITS[i].millis > n ? '< 1' : '0'}${DURATION_UNITS[i].title}`;
      }
    }
    return result;
  }
  return value; // Value is not a number, not adding $nor adornments
};

export {
  FixedDigitsFormatter,
  FIXED_DIGITS_FORMATTER_KEY,
  PercentageFormatter,
  PERCENTAGE_FORMATTER_KEY,
  DollarsFormatter,
  DOLLARS_FORMATTER_KEY,
  DateFormatter,
  DATE_FORMATTER_KEY,
  DurationFormatter,
  DURATION_FORMATTER_KEY,
};

